export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:3000";

export const STREAM_API_BASE_URL =
  import.meta.env.VITE_STREAM_API_BASE_URL || API_BASE_URL;


export const HELP_SITE_URL =
  import.meta.env.VITE_HELP_SITE_URL || "https://help.kassaro.se";
